import type { AppState } from 'state/state.model';

export function getPriceImprovementComment(state: AppState, rfpiId: string): string | undefined {
  return state.quotes.priceImprovementResponses[rfpiId]?.comment;
}

export function getPriceImprovementAcceptablePriceAdjustment(state: AppState, rfpiId: string): number | undefined {
  return state.quotes.priceImprovementResponses[rfpiId]?.acceptablePriceAdjustment;
}

export function getPriceImprovementValidationError(state: AppState, rfpiId: string) {
  return state.quotes.priceImprovementResponses[rfpiId]?.validationError;
}

export function getPriceImprovementRejectionError(state: AppState, rfpiId: string) {
  return state.quotes.priceImprovementResponses[rfpiId]?.rejectionError;
}
